import { defineStore } from 'pinia'
import { ref } from 'vue'

/**
 * The search term of a list page. Call it once per list at module level with a unique id,
 * export the result, and both slices `use…()` it.
 *
 * A store rather than a ref because the toolbar that writes the term and the table that
 * reads it are separate slices, neither owning the other. **Do not add pagination to it** —
 * a singleton page number breaks a list rendered twice on one screen; that state belongs to
 * `useEntityTable`, which owns one copy per table.
 */
export function createTableSearchStore(id: string) {
  return defineStore(id, () => {
    const search = ref('')

    function reset() {
      search.value = ''
    }

    return { search, reset }
  })
}
